"use client";

import { NoteFeature, Undercarriages } from "@/@types";
import UsedProductNoteFeaturesTable from "./UsedProductNoteFeaturesTable";

type Props = {
    undercarriages?: Undercarriages[];
    noteFeatures?: NoteFeature[];
}

export default function UsedProductUndercarriageContent({ undercarriages, noteFeatures }: Props) {
    if (!undercarriages || undercarriages.length === 0) {
        return <p className="font-bold">Sin información</p>;
    }

    return (
        <div>
            {noteFeatures && noteFeatures.length > 0 && (
                <UsedProductNoteFeaturesTable 
                    noteFeatures={noteFeatures}
                />
            )}
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm border border-gray-300">
                    <thead className="bg-gray-100 text-left">
                        <tr>
                            <th className="p-2 border">CONCEPTO</th>
                            <th className="p-2 border">MEDICIÓN IZQ</th>
                            <th className="p-2 border">% DESGASTE IZQ</th>
                            <th className="p-2 border">HORAS POSIBLES IZQ</th>
                            <th className="p-2 border">MEDICIÓN DER</th>
                            <th className="p-2 border">% DESGASTE DER</th>
                            <th className="p-2 border">HORAS POSIBLES DER</th>
                        </tr>
                    </thead>
                    <tbody>
                        {undercarriages.map((uc, index: number) => 
                            uc.undercarriageFeatures.map((feature, idx) => (
                                <tr key={`${index}-${idx}`} className="border-t">
                                    <td className="p-2 border">{feature.concept ?? "-"}</td>
                                    <td className="p-2 border">{feature.leftMeasurement ?? "-"}</td>
                                    <td className="p-2 border">{feature.leftWearPercentage ?? "-"}</td>
                                    <td className="p-2 border">{feature.leftPossibleHours ?? "-"}</td>
                                    <td className="p-2 border">{feature.rightMeasurement ?? "-"}</td>
                                    <td className="p-2 border">{feature.rightWearPercentage ?? "-"}</td>
                                    <td className="p-2 border">{feature.rightPossibleHours ?? "-"}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}